module.exports = __webpack_public_path__ + "img/gradient-1.a8cd2715.png";